import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const IconArrowLeft = ({ className, stroke = 'currentColor' }) => {
    return (
        <svg
            className={'icon-arrow-left' + (className ? ` ${className}` : '')}
            fill='none'
            height='44'
            width='44'
            xmlns='http://www.w3.org/2000/svg'><path
                d='m18.4855 10.0104-16.97087.0001m0 0 6.34315 6.3431m-6.34315-6.3431 6.36409-6.36409'
                stroke={stroke}
                strokeLinecap='round'/></svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string,
    stroke: PropTypes.string
};

IconArrowLeft.propTypes = propTypes;

export default IconArrowLeft;
